import React from "react";
import {
    FormControlLabel,
    Grid,
    IconButton,
    Radio,
    RadioGroup,
    Stack,
    Tooltip,
} from "@mui/material";
import OpenWithIcon from "@mui/icons-material/OpenWith";
import useLoadingAndInactiveDataHandler from "src/components/use-loading-and-inactive-data-handler";
import PipelineDurationCards from "src/components/pipeline-duration-cards";
import WorkflowPicker from "src/components/workflow-picker";
import PipelineStageModal from "src/scenes/dashboard/work-analytics/duration-per-pipeline-stage-modal";
import RepoPicker from "src/components/repo-picker";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";

const StageDurations = ({ fetchAction }) => {
    const test = false;
    if (test) return null;
    if (!fetchAction) return null;
    const [pipelineStageModal, setPipelineStageModal] = React.useState(false);
    const [repo, setRepo] = React.useState(undefined);
    const [workflow, setWorkflow] = React.useState(undefined);
    const [allWorkflows, setAllWorkflows] = React.useState(undefined);
    const [durationMode, setDurationMode] = React.useState("overall");

    React.useEffect(() => {
        if (fetchAction.status === "STREAMING") {
            setRepo(undefined);
        }
        if (fetchAction.status === "SUCCESS") {
            const availableRepos = Object.keys(
                fetchAction.data && fetchAction.data.durationPerStage
            );
            setRepo(availableRepos[0]);
        }
    }, [fetchAction]);

    React.useEffect(() => {
        if (fetchAction.status === "SUCCESS" && repo) {
            const availableWorkflows = Object.keys(
                fetchAction.data &&
                    fetchAction.data.durationPerStage &&
                    fetchAction.data.durationPerStage[repo]
            );
            setWorkflow(availableWorkflows[0]);
            setAllWorkflows(availableWorkflows);
        }
    }, [repo]);

    const showWorkflowPicker = () => {
        if (allWorkflows && allWorkflows.length <= 1 && allWorkflows[0] === repo) {
            return true;
        }
        return false;
    };

    // if (
    //     !isTeams &&
    //     (toolsScrapping.includes("gitlab") ||
    //         toolsScrapping.includes("github") ||
    //         toolsScrapping.includes("gitlabSelfManaged"))
    // )
    //     return <ScrappingPlaceholderSection variant={checkGitScrapping(toolsScrapping)} />;
    const { loadingAndInactiveHandler } = useLoadingAndInactiveDataHandler({
        name: "pipelines",
        fetchAction,
    });
    if (loadingAndInactiveHandler) return loadingAndInactiveHandler;

    const handleDurationModeChange = (e, value) => {
        setDurationMode(value);
    };
    return (
        <>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                style={{ width: "100%" }}
            >
                <Grid container direction="row" alignItems="center" style={{ width: "68%" }}>
                    <Grid item>
                        <RepoPicker
                            repo={repo}
                            setRepo={setRepo}
                            data={fetchAction.data && fetchAction.data.durationPerStage}
                        />
                    </Grid>
                    <Grid item>
                        {!showWorkflowPicker() && repo && (
                            <WorkflowPicker
                                workflow={workflow}
                                setWorkflow={setWorkflow}
                                data={fetchAction.data && fetchAction.data.durationPerStage[repo]}
                            />
                        )}
                    </Grid>
                </Grid>
                <FormControl>
                    <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={durationMode}
                        onChange={handleDurationModeChange}
                        row
                    >
                        <FormControlLabel
                            value="overall"
                            control={<Radio size="small" />}
                            label={
                                <Tooltip title="The duration it took for the stage to complete its tasks.">
                                    <Typography sx={{ fontSize: 12 }}>Execution time</Typography>
                                </Tooltip>
                            }
                        />
                        <FormControlLabel
                            value="total"
                            control={<Radio size="small" />}
                            label={
                                <Tooltip title=" Total time, including user interaction. Accounts for machine time and any manual steps involved.">
                                    <Typography sx={{ fontSize: 12 }}>Overall duration</Typography>
                                </Tooltip>
                            }
                        />
                    </RadioGroup>
                </FormControl>
                <IconButton
                    size="small"
                    aria-label="see knowledge base"
                    color="secondary"
                    onClick={() => setPipelineStageModal(true)}
                >
                    <OpenWithIcon
                        fontSize="small"
                        style={{
                            transform: "rotate(45deg)",
                            transformOrigin: "center",
                        }}
                    />
                </IconButton>
            </Stack>
            <PipelineDurationCards
                data={
                    fetchAction.data &&
                    fetchAction.data.durationPerStage &&
                    fetchAction.data.durationPerStage[repo] &&
                    fetchAction.data.durationPerStage[repo][workflow]
                }
                setPipelineStageModal={setPipelineStageModal}
                durationMode={durationMode}
            />
            <PipelineStageModal
                open={pipelineStageModal}
                workflow={workflow}
                allWorkflows={allWorkflows}
                setWorkflow={setWorkflow}
                repo={repo}
                setRepo={setRepo}
                durationMode={durationMode}
                handleDurationModeChange={handleDurationModeChange}
                data={
                    fetchAction.data &&
                    fetchAction.data.durationPerStage &&
                    fetchAction.data.durationPerStage[repo] &&
                    fetchAction.data.durationPerStage[repo][workflow]
                }
                fetchAction={fetchAction}
                handleClose={() => setPipelineStageModal(!pipelineStageModal)}
            />
        </>
    );
};

export default StageDurations;
